import Indicator from '../Indicator';

/** EMA indicator */
export default class EMAIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 * @property {object[]} componentSeries - Indicator component series
	 */
	_getDefaultParams() {
		return {
			id: 'ema',
			name: 'EMA',
			description:
				'Moving Averages are trend indicators that smooth stock price movements. Comparing the moving averages from multiple time frames can help investors spot changes in trend. Exponential Moving Averages add greater weight to more recent prices.',
			inputs: [{ name: 'period', value: 20 }],
			componentSeries: [{ id: 'ema' }]
		};
	}

	/**
	 * Renders the indicator
	 * @param {object} data - Symbol data object
	 * @property {string} sessionType - Session type (eg. NormalSession, SessionBreak)
	 */
	render(data, sessionType) {
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
